import { render, staticRenderFns } from "./search-responsible.vue?vue&type=template&id=28b2877a&scoped=true"
import script from "./search-responsible.vue?vue&type=script&lang=js"
export * from "./search-responsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b2877a",
  null
  
)

export default component.exports